import { Injectable } from '@angular/core';
import { isMatch, parse } from 'date-fns';

@Injectable({
  providedIn: 'root',
})
export class DateService {
  // constructor() {}

  public parseDateIfNeeded(dateString: string): Date {
    const format = 'dd/MM/yyyy';

    if (isMatch(dateString, format)) {
      return parse(dateString, format, new Date());
    }

    return new Date(dateString);
  }
}
